import ModalComponent from '@components/common/Modal';
import { IReflect } from '@models/Log';
import AdminLogApi from 'apis/api/AdminLog';
import React, { useEffect, useState } from 'react';
import { Descriptions, Tag, Divider } from 'antd';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FaPaperclip } from 'react-icons/fa';
import moment from 'moment';
import axios from 'axios';

interface IModalViewIpInfo {
  rowSelect?: IReflect;
  isOpen: boolean;
  callBackClose: () => any;
  callBackRefresh?: () => any;
}

function ModalViewIpInfo(props: IModalViewIpInfo) {
  const [data, setData] = useState<any>();

  const getInfoIp = async () => {
    const res = await axios.get(`https://ipinfo.io/${props.rowSelect.ip}/json`);
    setData(res.data);
  };

  const handleCancel = () => props.callBackClose();
  useEffect(() => {
    if (props.rowSelect.ip) {
      getInfoIp();
    }
  }, [props.rowSelect.ip]);

  return (
    <ModalComponent
      centered
      modalTitle="Thông tin IP"
      modalType="cancel"
      modalSize="medium"
      hiddenFooter
      visible={props.isOpen}
      onCancel={handleCancel}
    >
      {data && (
        <div className="p-2 mb-4">
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Địa chỉ IP">{data.ip}</Descriptions.Item>
            <Descriptions.Item label="Host name">{data.hostname}</Descriptions.Item>
            <Descriptions.Item label="Thành phố">{data.city}</Descriptions.Item>
            <Descriptions.Item label="Khu vực">{data.region}</Descriptions.Item>
            <Descriptions.Item label="Quốc gia">{data.country}</Descriptions.Item>
            <Descriptions.Item label="Loc">{data.loc}</Descriptions.Item>
            <Descriptions.Item label="Org">{data.org}</Descriptions.Item>
            <Descriptions.Item label="Postal">{data.postal}</Descriptions.Item>
            <Descriptions.Item label="TimeZone">{data.timezone}</Descriptions.Item>
            <Descriptions.Item label="ReadMe">{data.readme}</Descriptions.Item>
          </Descriptions>
        </div>
      )}
    </ModalComponent>
  );
}

export default ModalViewIpInfo;
